import { getAdminToken, isStaffToken, setAdminToken } from '../services/authService';

export const STAFF_VERSION_ERROR = 'The staff sign-in service is running an incompatible version. Update and restart the User and Security Service, then request a new verification code.';

export async function staffRequest(path, options = {}) {
  const { authenticated = true, ...requestOptions } = options;
  const response = await fetch(`/s1/admin${path}`, {
    ...requestOptions,
    headers: { 'Content-Type': 'application/json', ...(authenticated ? { Authorization: `Bearer ${getAdminToken()}` } : {}), ...requestOptions.headers },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw Object.assign(new Error(body.error || body.message || `The staff service could not complete this request (HTTP ${response.status}).`), { status: response.status });
  }
  return response;
}

export async function staffJSON(path, options) {
  const response = await staffRequest(path, options);
  try { return await response.json(); }
  catch { throw new Error('The staff API did not return JSON. Check the /s1 development proxy and backend service.'); }
}

export function requireStaffProfile(profile) {
  if (!profile || !['admin', 'marketing'].includes(profile.role) || !/^[1-9]\d*$/.test(String(profile.id))) {
    throw new Error(STAFF_VERSION_ERROR);
  }
  return profile;
}

// Verify the newly issued token against the same API before saving it or navigating.
// A legacy token or mismatched deployment must stay an error, not a login loop.
export async function completeStaffSignIn(token) {
  if (!isStaffToken(token)) throw new Error(STAFF_VERSION_ERROR);
  let profile;
  try {
    profile = requireStaffProfile(await staffJSON('/me', { headers: { Authorization: `Bearer ${token}` } }));
  } catch (err) {
    throw new Error(`Verification succeeded, but the staff session could not be validated. ${err.message}`);
  }
  setAdminToken(token);
  return profile;
}
